import { makeObservable, override } from 'mobx';
import sortBy from 'lodash/sortBy';
import remove from 'lodash/remove';

import { PlanData, PlanStatus, PlanWithVersions } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export interface PlanWithVersionParams extends PlanData {
    versions: PlanData[];
}

export class PlanVersionList extends LongList<PlanWithVersionParams, PlanWithVersions> {
    constructor(params?: PlanWithVersions[]) {
        super(params);
        makeObservable(this);
    }

    @override
    public set(params: PlanWithVersions[]): void {
        this.reset();

        this.add(params);
        this.offset = params.length !== 0 ? this.limit : 0;
    }

    @override
    public add(params: PlanWithVersions[]): void {
        params.forEach(planVersions => {
            const item = this.create(planVersions);

            this.list.set(item.id, item);
        });
    }

    @override
    public update(id: string, value: PlanWithVersionParams): void {
        const current = this.get(id);

        this.list.set(id, { ...current, ...value });
    }

    protected create(params: PlanWithVersions): PlanWithVersionParams {
        const versions = sortBy(params.versions, 'versionStartDate');

        let mainValue = versions.find(value => value.status === PlanStatus.Active);

        if (!mainValue) {
            mainValue = versions[0];
        }

        remove(versions, value => value.versionStartDate === mainValue.versionStartDate);

        return { ...mainValue, versions };
    }
}
